import {
	UPDATE_ITEM_INFO,
	UPDATE_DISPLAY_INFO,
	UPDATE_CATEGORIES,
	SET_ITEM_CATEGORY_DATA,
	SELECT_CATEGORY_DATA,
	SET_ITEM_ERRORS,
	UPDATE_ITEM_IMAGE,
	DELETE_ITEM_IMAGE,
	UPDATE_NEW_CATEGORY_IMAGE,
	DELETE_NEW_CATEGORY_IMAGE,
	RESET_ITEM_ERRORS,
	PAINT_ITEM_DATA,
	RESET_ITEM_INFO,
	SET_ITEM_WARNINGS,
	SET_ATTACHMENT_DATA_VENDOR,
	RESTORE_ITEM_IMAGE,
	IMAGE_UPLOAD_STATUS
} from "./types";
import config from "../../config/config";
import axios from "axios";
const apiDomain = config.apiDomains[0];

export const updateItemInfo = (payload, deleteNewCatImage = false) => async dispatch => {
	dispatch({
		type: UPDATE_ITEM_INFO,
		payload: payload,
		isDeleteNewCatImage: Boolean(deleteNewCatImage)
	});
};

export const updateItemDisplayInfo = payload => async dispatch => {
	dispatch({
		type: UPDATE_DISPLAY_INFO,
		payload: payload
	});
};

export const setItemErrors = payload => async dispatch => {
	dispatch({
		type: SET_ITEM_ERRORS,
		payload: payload
	});
};

export const setItemWarnings = payload => async dispatch => {
	dispatch({
		type: SET_ITEM_WARNINGS,
		payload: payload
	});
};

export const updateItemCategories = payload => async dispatch => {
	dispatch({
		type: UPDATE_CATEGORIES,
		payload: payload
	});
};

export const setCategoryList = (options = {}) => {
	return dispatch => {
		axios
			.get(
				`${apiDomain}/marketplace/products/groups/ajax/getAllGroupsBySupplier.service`
			)
			.then(data => {
				options.cb && options.cb(data.data);
				dispatch({
					type: SET_ITEM_CATEGORY_DATA,
					payload: {
						data: data.data,
						appliedOnIds: options.appliedOnIds
					}
				});
			});
	};
};

export const selectCatItem = (options = {}) => {
	return (dispatch) => {
		dispatch({
			type: SELECT_CATEGORY_DATA,
			payload: {
				...options
			}
		});
	};
};


export const updateItemImage = payload => dispatch => {
	dispatch({
		type: UPDATE_ITEM_IMAGE,
		payload: {
			...payload
		}
	});
};

export const restoreItemImage = payload => dispatch => {
	dispatch({
		type: RESTORE_ITEM_IMAGE,
		payload
	})
}

export const deleteItemImage = payload => async dispatch => {
	dispatch({
		type: DELETE_ITEM_IMAGE,
		payload
	});
};

export const updateNewCategoryImage = payload => dispatch => {
	dispatch({
		type: UPDATE_NEW_CATEGORY_IMAGE,
		payload: {
			...payload
		}
	});
};
export const deleteNewCategoryImage = payload => async dispatch => {
	dispatch({
		type: DELETE_NEW_CATEGORY_IMAGE,
		payload
	});
};
export const resetErrors = payload => dispatch => {
	dispatch({
		type: RESET_ITEM_ERRORS,
		payload: payload
	})
}
export const fetchProductDetails = payload => async dispatch => {
	const res = await axios.get(`${apiDomain}/marketplace/products/admin/ajax/checkTemplatedIsApproved.service?isTemplate=true&productId=${payload.productId}`);
	if (res.data.isValidate) {
		const details = await axios.get(`${apiDomain}/marketplace/products/ajax/services/edit/${payload.productId}.service?action=undefined&PuvId=undefined&isTemplate=true`)
		dispatch({
			type: PAINT_ITEM_DATA,
			payload: details.data
		})
		payload.cb && payload.cb();
	}
}
export const resetItemInfo = payload => dispatch => {
	dispatch({
		type: RESET_ITEM_INFO,
		payload: payload
	})
}

export const fetchDataAndEdit = payload => async dispatch => {
	// commented as per discussed with Anshul
	// const res = await axios.get('/vendorapis/supplierForm/supplierForm/getsupplierform')
	// if(res.data.isSuccesss){
	const details = await axios.get(`${apiDomain}/marketplace/static/php/web/b2bWebsite.php?action=getProductDetails&token=${payload.token}&productId=${payload.itemId}`)
	// let consignmentData = details.data.productCommand.consignmentCommand;
	const productId = details?.data?.data?.productId || '';
	let attachmentDataVendor = details.data.data.attachmentData || [];
	let fileAttachmentDataVendor = attachmentDataVendor.length > 0 ? JSON.parse(attachmentDataVendor) : [];
	let paintedData = {
		productCommand: details?.data?.data
	}
	dispatch({
		type: SET_ATTACHMENT_DATA_VENDOR,
		payload: {
			productId,
			fileAttachmentDataVendor
		}
	});
	dispatch({
		type: PAINT_ITEM_DATA,
		payload: {
			...paintedData,
			isEdit: true
		}
	})
	payload.cb && payload.cb();
	// }
}

export const setMultiImageUploadStatus = payload => (dispatch) => {
	dispatch({
		type: IMAGE_UPLOAD_STATUS,
		payload: payload
	})
}